import React from "react";
import {
  DevelopmentDataType,
  developmentData,
} from "../../content/data/GoodsData";
import {
  DevContainer,
  DevItemsContainer,
  DevItemsDescription,
  Title,
  GoodTag,
  CardInner,
  CardFront,
  FlexScroll,
  CardInfo,
  LogoWrapper,
  OrderNumber,
  GoodsContainer,
} from "./styles";
import { FlexWrap } from "../MainBlock/styles";
import useIsMobile from "../../common/hooks/useIsMobile";
import clsx from "clsx";

const Goods = () => {
  const mappedData = developmentData.map(
    ({ title, MainLogo, desc, additionalData, tags }, ind) => (
      <DevelopmentBlock
        key={`dev-${ind}`}
        title={title}
        MainLogo={MainLogo}
        desc={desc}
        additionalData={additionalData}
        tags={tags}
        ind={ind + 1}
      />
    )
  );

  const isMobile = useIsMobile();

  return (
    <DevContainer>
      <FlexScroll gap={clsx(!isMobile ? "1vw" : "2vw")}>
        {mappedData}
      </FlexScroll>
    </DevContainer>
  );
};

const DevelopmentBlock = ({
  title,
  MainLogo,
  desc,
  tags,
  additionalData,
  ind,
}: DevelopmentDataType & { ind: number }) => {
  return (
    <DevItemsContainer direction="column">
      <CardInner grow={1}>
        <CardFront>
          <OrderNumber>
            {"("}0{ind}
            {")"}
          </OrderNumber>
          <GoodsContainer direction="column" grow={1}>
            <LogoWrapper>{MainLogo && <MainLogo />}</LogoWrapper>
            <CardInfo direction="column">
              <Title>{title}</Title>
              <FlexWrap>
                {tags.map((el, ind) => (
                  <GoodTag key={`tag-${ind}`}>{el}</GoodTag>
                ))}
              </FlexWrap>
              <DevItemsDescription>{desc}</DevItemsDescription>
            </CardInfo>
          </GoodsContainer>
        </CardFront>
      </CardInner>
    </DevItemsContainer>
  );
};

export default Goods;
